export default "__VITE_ASSET__AKWArQnT__"